import { render, staticRenderFns } from "./create-exam.vue?vue&type=template&id=d9a3fbf6"
import script from "./create-exam.vue?vue&type=script&lang=js"
export * from "./create-exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports